import { useState } from "react";
import { getLatestDramas } from "@/utils/content";
import DramaCard from "@/components/feature/DramaCard";
import SectionHeading from "@/components/feature/SectionHeading";

const tabs = ["全部", "电视剧", "电影", "综艺"];

export default function LatestSection() {
  const [tab, setTab] = useState("全部");
  const latest = getLatestDramas(12);
  const list = tab === "全部" ? latest : latest.filter((item) => item.category === tab);

  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 py-8 md:px-6 md:py-12">
      <SectionHeading
        title="最新剧集推荐"
        subtitle="近期上线的热门影视作品，追剧从这里开始"
        icon="ri-movie-line"
        moreTo="/category"
      >
        <div className="flex items-center gap-1 rounded-full bg-background-100 p-1">
          {tabs.map((item) => (
            <button
              key={item}
              type="button"
              onClick={() => setTab(item)}
              className={`whitespace-nowrap rounded-full px-3 py-1.5 text-sm font-medium transition-colors ${
                tab === item ? "bg-primary-500 text-background-50" : "text-foreground-600 hover:text-primary-600"
              }`}
            >
              {item}
            </button>
          ))}
        </div>
      </SectionHeading>

      {list.length > 0 ? (
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4 lg:grid-cols-4 xl:grid-cols-5">
          {list.map((drama) => (
            <DramaCard key={drama.id} drama={drama} />
          ))}
        </div>
      ) : (
        <p className="rounded-lg border border-background-200 bg-background-50 p-8 text-center text-sm text-foreground-500">
          该分类下暂无内容
        </p>
      )}
    </section>
  );
}